import { serializeData } from "../utils"

function extractParamsFromNextUrl<T>(nextUrl: string): T {
  const urlObj = new URL(nextUrl)
  const params = new URLSearchParams(urlObj.search)
  const paramsObj = Object.fromEntries(params)
  return serializeData(paramsObj) as T
}

export { extractParamsFromNextUrl }
